import { Col, Row, Space, Typography } from "antd";
import {
  PHONE_ICON,
  MSG_ICON,
  LOCATION_ICON,
  CHAT_ICON,
  PERSON_ICON,
} from "assets";
import { CustomInput } from "global/components";
import { ReactSVG } from "react-svg";

const ContactUsSection = () => {
  return (
    <section className="contact-us-section section-margin-top">
      <div className="contact-us-section-inner container">
        <Row>
          <Col xs={24} md={12}>
            <ContactInfo />
          </Col>
          <Col xs={24} md={12}>
            <ContactForm />
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default ContactUsSection;

const ContactInfo = () => (
  <div className="contact-us-section-info">
    <Typography.Title className="m-0" level={3}>
      Contact Us
    </Typography.Title>
    <Typography.Paragraph>
      Reach out to HSTC Engineering for innovative solutions in the military,
      defense, and security sectors. We're committed to providing exceptional
      customer service and protecting lives and assets
    </Typography.Paragraph>
    <Space direction="vertical" size={30} style={{ marginTop: 24 }}>
      <Space align="center">
        <ReactSVG src={LOCATION_ICON} />
        <Typography.Paragraph className="m-0">
          31 Briekslinger Place, Wapadrand Ext 1, Pretoria, 0050
        </Typography.Paragraph>
      </Space>
      <Space>
        <ReactSVG src={PHONE_ICON} />
        <Typography.Paragraph className="m-0">
          {"+27 (0)82 324 9534"}
        </Typography.Paragraph>
      </Space>
      <Space>
        <ReactSVG src={MSG_ICON} />
        <Typography.Paragraph className="m-0">
          hennie.stander@hstcengineering.com
        </Typography.Paragraph>
      </Space>
    </Space>
  </div>
);

const ContactForm = () => {
  return (
    <div className="contact-us-section-form">
      <Typography.Title className="m-0" level={3}>
        Get In Touch
      </Typography.Title>
      <Typography.Paragraph className="m-0">
        Mega bold action. Sold care wherever less appetizing your far easily
      </Typography.Paragraph>
      <div className="contact-us-section-form-wrapper">
        <CustomInput placeholder="Name" icon={MSG_ICON} />
        <CustomInput placeholder="Email" icon={PERSON_ICON} />
        <CustomInput
          type="textarea"
          placeholder="Your Message"
          icon={CHAT_ICON}
        />
        <button className="notched-primary-btn">Send Message</button>
      </div>
    </div>
  );
};
